import React , {useState,useEffect, ReactNode} from "react";
import withPageContext from "../context/pageContext";
import { useLocalization } from "gatsby-theme-i18n";
import { GlobalStyles } from 'twin.macro'
import { useStaticQuery, graphql, navigate  } from "gatsby"
import { LocalizedLink } from "gatsby-theme-i18n";
import { animateScroll as scroll, scroller } from 'react-scroll'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import SVGDef from '../assets/images/SVG_def.inline.svg';
import QRCodeSection from "../sections/common/QRCodeSection";
import { withCookies } from 'react-cookie';
import { LocaleProvider } from "gatsby-theme-i18n";
import Header from '../components/Header';

const alertJson = require('../../locales/alert.json');

import {
  GlobalStyles as ComponentLibraryStyle,
  ThemeProvider,
  FooterWrapper,
  FooterSateliteSiteList,
  FooterSitemap,
  FooterSocialMediaList,
  XButton,
  FacebookButton,
  InstagramButton,
  YoutubeButton,
  TwitchButton
} from 'ffxiv-html-components/style-library';

import { usePageContext } from "../context/pageContext/hook";

import { withPrefix } from 'gatsby';

type Props = {
  children?: ReactNode;
};

const PageTemplate = (props) => {
  const { currentLocaleObj, t } = useLocalization();
  const { pageContext } = usePageContext();
  
  const [ showQR, setShowQR ] = useState(false);

  const userAgent = typeof navigator !== "undefined" ? navigator.userAgent   /*`Mozilla/5.0 (PlayStation; PlayStation 4/8.01) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/12.0 Safari/605.1.15`*/ : ``;
  const PSRegEx = new RegExp(/PlayStation/gm);

  useEffect(() => {
    if(PSRegEx.test(userAgent))
    {
      setTimeout(() => {
        setShowQR(true);
      },10);
    }
  },[]);

  const {
      footer_logo
  } = useStaticQuery<GatsbyTypes.PageTemplateQuery>(graphql`
    query PageTemplateQuery{
      footer_logo : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "footer_logo.png"}) {
          childImageSharp {
            gatsbyImageData(
              placeholder: NONE
              formats: [PNG]
            )
          }
        }
      }




    `);

  return (<>
    <noscript>
        <div dangerouslySetInnerHTML={{__html: `<div id="alert" class="mask" style="position:fixed;top:0;left:0;bottom:0;right:0;background:#F7F7FA;line-height:100vh;z-index:9999;text-align:center;"><div class="alert_box" style="display:inline-block;position:relative;width:928px;max-width:100%;box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);border-radius: 6px;background: #FCFCFF;padding:108px 48px 96px;color:#444448;font-size: 20px;line-height: 32px;text-align:center;margin:100px auto;vertical-align:middle;"><img style="width:104px;height:104px;display:block;margin:0 auto 44px;"src="${withPrefix('notice.png')}" />${alertJson[currentLocaleObj.code].javascript}</div></div>`}}/>
    </noscript>
    {props.pageContext.type === "page" && <Header theme={'dark'} />}
    {showQR &&
      <QRCodeSection uri={pageContext.urlQRCode}/>
    }
    <main>
      <>
        {props.children}
      </>
      {props.pageContext.type === "page" && <FooterWrapper copyrightText={[t('common_footerCopyright.footer.copyright'), t('common_footerCopyright.footer.copyright.option')]} copyrightLogoLink={t('common_footerCopyright.footer.sqex.logo.url')}>
        <FooterSateliteSiteList region={'ja'} />
        <FooterSitemap sitemap={[{
          title: t('common_footerNav.footer.nav.event.label'),
          list: [{
            label: t('common_nav.home.label'),
            link: '#top',
            onClick : (e) => {
              e.preventDefault();
              if(pageContext.namespace === "home")
              {
                scroll.scrollToTop();
                if(window)
                {
                  if (window.history.pushState) {
                      // IE10, Firefox, Chrome, etc.
                      window.history.pushState(null, '', window.location.pathname);
                  } else {
                      // IE9, IE8, etc
                      window.location.hash = ``;
                  }
                }
              }
              else
              {
                navigate('/');
              }
            }
          }, {
            label: t('common_nav.about.label'),
            link: withPrefix('/about'),
            onClick : (e) => {
              e.preventDefault();
              navigate('/about');
            }
          }, {
            label: t('common_nav.ticket.label'),
            link: withPrefix('/tickets'),
            onClick : (e) => {
              e.preventDefault();
              navigate('/tickets');
            }
          }, {
            label: t('common_nav.program.label'),
            link: withPrefix('/program'),
            onClick : (e) => {
              e.preventDefault();
              navigate('/program');
            }
          }, {
            label: t('common_nav.activity.label'),
            link: '#activities',
            onClick : (e) => {
              e.preventDefault();
              navigate('/activities');
            }
          }, {
            label: t('common_nav.contest_campaign.label'),
            link: withPrefix('/contest_campaign'),
            onClick : (e) => {
              e.preventDefault();
              navigate('/contest_campaign');
            }
          }, {
            label: t('common_nav.floormap.label'),
            link: withPrefix('/floormap'),
            onClick : (e) => {
              e.preventDefault();
              navigate('/floormap');
            }
          },{
            label: t('common_nav.ingame_item.label'),
            link: '#inGame_item',
            onClick : (e) => {
              e.preventDefault();
              if(pageContext.namespace === "home")
              {
                scroller.scrollTo('inGame_item', {
                  duration: 500,
                  smooth: true,
                  offset: -200,
                });
                if(window)
                {
                  if (window.history.pushState) {
                      // IE10, Firefox, Chrome, etc.
                      window.history.pushState(null, '', `#inGame_item`);
                  } else {
                      // IE9, IE8, etc
                      window.location.hash = `#inGame_item`;
                  }
                }
              }
              else
              {
                navigate('/#inGame_item');
              }
            }
          }, {
            label: t('common_nav.goods.label'),
            link: withPrefix('/goods'),
            onClick : (e) => {
              e.preventDefault();
              navigate('/goods');
            }
          },{
            label: t('common_nav.stream.label'),
            link: '/about/#streaming',
            onClick : (e) => {
              e.preventDefault();
              if(pageContext.namespace === "about")
              {
                scroller.scrollTo('streaming', {
                  duration: 500,
                  smooth: true,
                  offset: -200,
                });
                if(window)
                {
                  if (window.history.pushState) {
                      // IE10, Firefox, Chrome, etc.
                      window.history.pushState(null, '', `/about/#streaming`);
                  } else {
                      // IE9, IE8, etc
                      window.location.hash = `#streaming`;
                  }
                }
              }
              else
              {
                navigate('/about/#streaming');
              }
            }
          }]
        }, {
          title: t('common_footerNav.footer.nav.fanfest.label'),
          list: [{
            label: t('common_footerNav.footer.nav.fanfest.vegas_2023.label'),
            link: t('common_footerNav.footer.nav.fanfest.vegas_2023.url'),
            target: '_blank'
          }, {
            label: t('common_footerNav.footer.nav.fanfest.london_2023.label'),
            link: t('common_footerNav.footer.nav.fanfest.london_2023.url'),
            target: '_blank'
          }]
        }, {
          title: t('common_footerNav.footer.nav.site.label'),
          list: [{
            label: t('common_footerNav.footer.nav.site.privacy.label'),
            link: t('common_footerNav.footer.nav.site.privacy.url'),
            target: '_blank'
          }, {
            label: t('common_footerNav.footer.nav.site.license.label'),
            link: t('common_footerNav.footer.nav.site.license.url'),
            target: '_blank'
          }]
        }]}>

          <LocalizedLink to={'/'}><GatsbyImage image={getImage(footer_logo)} alt={t('common_event.name.ja.full')} /></LocalizedLink>
        </FooterSitemap>
        <FooterSocialMediaList>
          <XButton link={t('common_social.sns.twitter.url')} />
          <FacebookButton link={t('common_social.sns.facebook.url')} />
          <InstagramButton link={t('common_social.sns.instagram.url')} />
          <YoutubeButton link={t('common_social.sns.youtube.url')} />
          <TwitchButton link={t('common_social.sns.twitch.url')} />
        </FooterSocialMediaList>
      </FooterWrapper>
      }
      
      <SVGDef />
    </main>
    </>
  );
}
 
export default PageTemplate;
